import {
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import { useState, useEffect } from 'react';
import { FaEdit } from 'react-icons/fa';
import { MdDelete, MdOutlineDeleteOutline } from 'react-icons/md';
import { PiWarningCircleBold } from 'react-icons/pi';
// Custom components
import * as React from 'react';
import { IoMdAdd } from 'react-icons/io';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Dropdown, Form } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import ReactPaginate from 'react-paginate';
import { IoSearchOutline } from 'react-icons/io5';
import { RiDownloadCloudLine } from 'react-icons/ri';

import {
  getAbout,
  productDropdown,
  searchHsn,
  searchPatient,
} from '../../../redux/actions/Master.action';
import { Formik, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { FiPlusCircle } from 'react-icons/fi';
import {
  batchDropdown,
  patientDropdown,
} from '../../../redux/actions/Admin.action';
import {
  addSaleBill,
  deleteSaleBill,
  getSaleBill,
  updateSaleBill,
  viewSaleBill,
} from '../../../redux/actions/Billing.action';
import { VscTarget } from 'react-icons/vsc';
import { useRef } from 'react';
import { toast } from 'react-toastify';
import SalesPrint from './SalesPrint';
import { toWords } from 'number-to-words';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

export default function SalesInvoice() {
  const newWindowRef = useRef(null);
  const billRef = useRef();
  const batchRefs = useRef([]);
  const [readyToPrint, setReadyToPrint] = useState(false);
  const [show, setShow] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [printModal, setPrintModal] = useState(false);
  const [shareWhasapp, setShareWhasapp] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [ids, setIds] = useState(null);
  const inputRefs = useRef({
    qty: null,
    discount: null,
  });
  const [selectedId, setSelectedId] = useState(null);
  const productRefs = useRef([]);
  const [isProductSelected, setIsProductSelected] = useState(false);
  const [mainPage, setMainPage] = useState('1');
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState('');
  const [searchProduct, setSearchProduct] = useState('');
  const getTodayDate = () => new Date().toISOString().split('T')[0];
  const [searchDefault, setSearchDefault] = useState({
    page: '',
    search: '',
  });
  const [dropdownValues, setDropdownValues] = useState({
    name: '',
    batchNo: '',
    inHouse: 'No',
    productName: '',
    paymentType: '',
  });

  const [initialValues, setInitialValues] = useState({
    patientName: '',
  });
  const [searchTerm, setSearchTerm] = useState('');

  const validationSchema = Yup.object().shape({
    patientName: Yup.string().required('Patient name requird*'),
  });
  const toggle = () => {
    setShow(!show);
    setFormData({
      patientId: '',
      phoneNumber: '',
      city: '',
      invoiceDate: getTodayDate(),
      inHouse: '',
      paymentType: '',
      productList: [
        {
          productId: '',
          productName: '',
          pack: '',
          hsnCode: '',
          batchNo: '',
          mrp: '',
          expDate: '',
          qty: '',
          discount: '',
          rate: '',
          gst: '',
          amount: '',
        },
      ],
      remark: '',
      grossAmount: '',
      discountAmount: 0,
      cDiscount: '',
      charges: '',
      billAmount: 0,
    });
    setSearchTerm('');
  };
  const updateToggle = () => {
    setUpdateModal(!updateModal);
    setFormData({
      patientId: '',
      phoneNumber: '',
      city: '',
      invoiceDate: getTodayDate(),
      inHouse: '',
      paymentType: '',
      productList: [
        {
          productId: '',
          productName: '',
          pack: '',
          hsnCode: '',
          batchNo: '',
          mrp: '',
          expDate: '',
          qty: '',
          discount: '',
          rate: '',
          gst: '',
          amount: '',
        },
      ],
      remark: '',
      grossAmount: '',
      discountAmount: 0,
      cDiscount: '',
      charges: '',
      billAmount: 0,
    });
  };

  const printData = useSelector((state) => state.bills);
  const aboutData = useSelector((state) => state.master);

  const userData = printData?.viewSaleBill?.data?.data;
  console.log('userData', userData);

  useEffect(() => {
    dispatch(viewSaleBill(selectedId));
    dispatch(getAbout());
  }, [selectedId]);
  const aboutInfo = aboutData?.getAbout?.data?.data?.map((res) => {
    return res;
  });
  console.log('aboutInfo', aboutInfo);

  const totalQty = userData?.productList?.reduce(
    (sum, res) => sum + Number(res.qty),
    0,
  );
  const totalDis = userData?.productList?.reduce(
    (sum, res) => sum + Number(res.discount),
    0,
  );
  // const totalAmount = userData?.productList?.reduce((sum, res) => sum + Number(res.amount || 0), 0) || 0;
  const totalAmount = parseFloat(userData?.billAmount) || 0;
  console.log('totalAmount', totalAmount);

  const totalAmountInWords = toWords(totalAmount);

  const deleteToggle = () => {
    setDeleteModal(!deleteModal);
  };
  const viewToggle = () => {
    setViewModal(!viewModal);
  };
  const printToggle = () => {
    setPrintModal(!printModal);
  };

  const shareWhasappToggle = () => {
    setShareWhasapp(!shareWhasapp);
  };

  const handleView = (pId) => {
    dispatch(viewSaleBill(pId));
    setSelectedId(pId);
  };

  const dispatch = useDispatch();
  const salesData = useSelector((state) => state.master);
  const dropdown = useSelector((state) => state.admin);
  const bills = useSelector((state) => state.bills);

  const [formData, setFormData] = useState({
    patientName: '',
    phoneNumber: '',
    city: '',
    invoiceDate: getTodayDate(),
    inHouse: 'No',
    paymentType: '',
    productList: [
      {
        productId: '',
        productName: '',
        pack: '',
        hsnCode: '',
        batchNo: '',
        mrp: '',
        expDate: '',
        qty: '',
        discount: '',
        rate: '',
        gst: '',
        amount: '',
        totalAmount: '',
      },
    ],
    remark: '',
    grossAmount: '',
    sgst: '',
    cgst: '',
    discountAmount: 0,
    cDiscount: '',
    charges: '',
    billAmount: 0,
  });
  const [dropdownData, setDropdownData] = useState([]);
  const [isDropdownVisible, setDropdownVisible] = useState(false);
  const role = localStorage.getItem('role');
  console.log('formData', formData);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (searchTerm.trim()) {
        dispatch(searchPatient(searchTerm));
        setDropdownVisible(true);
      } else {
        setDropdownVisible(false);
      }
    }, 300);

    return () => clearTimeout(timer);
  }, [searchTerm, dispatch]);

  const handleSelect = (selected) => {
    setFormData((prev) => ({
      ...prev,
      patientName: selected.name || searchTerm,
      phoneNumber: selected.phoneNumber,
      city: selected.city,
    }));
    setSearchTerm(selected.name);
    setDropdownVisible(false);
  };

  const handleAddRow = () => {
    setFormData((prev) => ({
      ...prev,
      productList: [
        ...prev.productList,
        {
          productName: '',
          hsnCode: '',
          pack: '',
          mrp: '',
          batchNo: '',
          expDate: '',
          discount: '',
          rate: '',
          qty: '',
          amount: '',
          gst: '',
        },
      ],
    }));

    setTimeout(() => {
      const newIndex = formData.productList.length;
      const dropdownToggle = productRefs.current[newIndex]?.querySelector(
        '[id="dropdown-basic"]',
      );
      if (dropdownToggle) {
        dropdownToggle.click();
      }
    }, 0);
  };

  const limits = {
    page: mainPage,
    limit: rowsPerPage,
    search: '',
  };

  const handleData = (e, res, index) => {
    if (res) {
      if (res.productName) {
        dispatch(batchDropdown({ productId: res._id }));
        setFormData((prev) => ({
          ...prev,
          productList: prev.productList.map((product, i) =>
            i === index
              ? {
                  ...product,
                  productId: res._id,
                  productName: res.productName,
                  hsnCode: res.hsnCode,
                  pack: res.salePack,
                  gst: res.gst,
                }
              : product,
          ),
        }));
        setDropdownValues((prev) => ({
          ...prev,
          productName: res.productName,
        }));
      } else if (res.name) {
        setFormData((prev) => ({
          ...prev,
          patientName: res.name,
          phoneNumber: res.phoneNumber,
          city: res.city,
        }));

        setDropdownValues((prev) => ({
          ...prev,
          name: res.name,
        }));
      } else {
        const { name, value } = e.target;
        setFormData((prev) => ({
          ...prev,
          [name]: value,
          phoneNumber: res.phoneNumber,
          city: res.city,
        }));
      }
    } else {
      const { name, value } = e.target;
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
      if (name === 'inHouse') {
        setDropdownValues((prev) => ({
          ...prev,
          inHouse: value,
        }));
      }
      if (name === 'paymentType') {
        setDropdownValues((prev) => ({
          ...prev,
          paymentType: value,
        }));
      }
    }
  };

  const handleBatchData = (res, index) => {
    if (res.qty === 0) {
      toast.error('Batch with zero quantity cannot be selected!');
      return;
    }

    setFormData((prev) => {
      return {
        ...prev,
        productList: prev.productList.map((product, i) => {
          if (i !== index) {
            return product;
          }

          const inRate = parseFloat(res.inRate || 0);
          const netRate = parseFloat(res.netRate || 0);

          const rateToUse =
            prev.inHouse === 'Yes'
              ? inRate > 0
                ? inRate
                : netRate > 0
                  ? netRate
                  : res.mrp
              : res.mrp;

          // Use previous values of qty and discount for recalculating
          const qty = parseFloat(product.qty) || 0;
          const discount = parseFloat(product.discount) || 0;
          const gst = parseFloat(product.gst) || 0;

          // Calculate new rate after discount
          const rate = rateToUse - (rateToUse * discount) / 100;

          // Calculate amount (rate * qty)
          const amount = (rate * qty).toFixed(2);

          // Calculate totalAmount (including GST if applicable)
          // const gstAmount = prev.inHouse !== "No" ? (amount * gst) / 100 : 0;
          // const totalAmount = (parseFloat(amount) + gstAmount).toFixed(2);

          const gstAmount = (amount * gst) / 100;
          const totalAmount =
            prev.inHouse === 'Yes'
              ? (parseFloat(amount) + gstAmount).toFixed(2)
              : (parseFloat(amount) - gstAmount).toFixed(2);

          return {
            ...product,
            batchNo: res.batchNumber,
            mrp: res.mrp,
            inRate: res.inRate || 0,
            netRate: res.netRate || 0,
            originalMrp: res.mrp,
            expDate: res.expDate,
            rate: rate.toFixed(2),
            amount,
            totalAmount,
            isBatchUpdated: true,
          };
        }),
      };
    });

    setIsProductSelected(true);
  };

  useEffect(() => {
    if (isProductSelected) {
      if (inputRefs.current.discount) {
        setTimeout(() => {
          inputRefs.current.discount.focus();
          setIsProductSelected(false);
        }, 100);
      }
    }
  }, [isProductSelected]);

  const handleKeyDown = (fieldName, e, index) => {
    if (e.key === 'Enter') {
      e.preventDefault();

      const fields = ['discount', 'qty'];
      const currentIndex = fields.indexOf(fieldName);

      if (currentIndex !== -1 && currentIndex < fields.length - 1) {
        const nextFieldName = fields[currentIndex + 1];
        if (inputRefs.current[nextFieldName]) {
          inputRefs.current[nextFieldName].focus();
        }
      }
    }
    if (fieldName === 'qty' && e.key === 'Enter') {
      e.preventDefault();
      const product = formData.productList[index];
      if (!product.qty || isNaN(product.qty) || parseFloat(product.qty) <= 0) {
        toast.error('Please enter a valid quantity before adding a new row.');
        return;
      }
      handleAddRow();
    }
  };

  const calculateProductTotals = (productList) => {
    return productList.map((product) => {
      if (product.isBatchUpdated) {
        return product;
      }
      const discount = parseFloat(product.discount || 0);
      const qty = parseFloat(product.qty || 0);
      const mrp = parseFloat(product.mrp || 0);

      const rate = mrp - (mrp * discount) / 100;
      const amount = rate * qty;

      return {
        ...product,
        rate: rate.toFixed(2),
        amount: amount.toFixed(2),
      };
    });
  };

  const handleProductChange = (e, index) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
        ...prev,
        productList: prev.productList.map((product, i) => {
            if (i !== index) return product;
            const inRate = parseFloat(product.inRate || 0);
            const netRate = parseFloat(product.netRate || 0);
            const originalMrp = parseFloat(product.originalMrp || product.mrp || 0);
            const rateToUse =
                prev.inHouse === 'Yes'
                    ? (inRate > 0 ? inRate : netRate > 0 ? netRate : originalMrp)
                    : originalMrp;
            const discount = name === 'discount' ? parseFloat(value) || 0 : parseFloat(product.discount) || 0;
            const qty = name === 'qty' ? parseFloat(value) || 0 : parseFloat(product.qty) || 0;
            const gst = parseFloat(product.gst) || 0;
            const rate = rateToUse - (rateToUse * discount) / 100;
            const amount = (rate * qty).toFixed(2);
            const gstAmount = (amount * gst) / 100;
            const totalAmount = prev.inHouse === "Yes"
                ? (parseFloat(amount) + gstAmount).toFixed(2)
                : (parseFloat(amount) - gstAmount).toFixed(2);
            return {
                ...product,
                [name]: value,
                rate: rate.toFixed(2),
                amount,
                totalAmount,
            };
        }),
    }));
};

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const DownloadPdf = async () => {
    const invoiceElement = document.getElementById('invoice'); // Reference to the invoice div

    if (!invoiceElement) {
      console.error('Invoice element not found');
      return;
    }

    try {
      // Ensure the element is temporarily visible for rendering
      invoiceElement.classList.remove('d-none');

      // Convert HTML to Canvas
      const canvas = await html2canvas(invoiceElement, {
        scale: 2, // Higher scale for better quality
        useCORS: true, // Fixes image loading issues
      });

      // Convert Canvas to Image
      const imageData = canvas.toDataURL('image/png');

      // Create PDF
      const pdf = new jsPDF('p', 'mm', 'a4');
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const imgWidth = pdfWidth;
      const imgHeight = (canvas.height * imgWidth) / canvas.width; // Maintain aspect ratio

      pdf.addImage(imageData, 'PNG', 0, 0, imgWidth, imgHeight);

      // Save PDF
      pdf.save('invoice.pdf');

      // Hide the invoice element again
      invoiceElement.classList.add('d-none');
    } catch (error) {
      console.error('Error generating PDF:', error);
    }
  };

  const fetchImageAsBase64 = async (imageUrl) => {
    try {
      const response = await fetch(imageUrl, { mode: 'cors' });
      const blob = await response.blob();
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
      });
    } catch (error) {
      console.error('Error fetching image as Base64:', error);
      return null;
    }
  };

  const calculateAmounts = () => {
    const grossAmount = formData.productList.reduce(
      (sum, product) => sum + (parseFloat(product.totalAmount) || 0),
      0,
    );

    const totalGST = formData.productList.reduce(
      (sum, product) =>
        sum +
        ((parseFloat(product.amount) || 0) * (parseFloat(product.gst) || 0)) /
          100,
      0,
    );

    const sgst = totalGST / 2;
    const cgst = totalGST / 2;

    const discountAmount = formData.discountAmount || 0;
    const discountPercentage = formData.cDiscount || 0;

    // let billAmount = formData.productList.reduce((sum, product) => sum + (parseFloat(product.totalAmount) || 0), 0);
    let billAmount;
    if (formData.inHouse === 'Yes') {
      billAmount = grossAmount;
    } else {
      billAmount = grossAmount + sgst + cgst;
    }
    if (discountAmount > 0) {
      billAmount -= discountAmount;
    } else if (discountPercentage > 0) {
      billAmount -= (billAmount * discountPercentage) / 100;
    }

    setFormData((prev) => ({
      ...prev,
      sgst: sgst.toFixed(2),
      cgst: cgst.toFixed(2),
      billAmount: billAmount.toFixed(2),
      grossAmount: grossAmount.toFixed(2),
    }));
  };

  useEffect(() => {
    calculateAmounts();
  }, [formData.productList, formData.discountAmount, formData.cDiscount]);

  useEffect(() => {
    setFormData((prev) => {
      const updatedProductList = prev.productList.map((product) => {
        // Skip rows where batch hasn't been selected yet
        if (!product.batchNo) return product;

        const inRate = parseFloat(product.inRate || 0);
        const netRate = parseFloat(product.netRate || 0);
        const originalMrp = parseFloat(product.originalMrp || product.mrp || 0);

        const rateToUse =
          prev.inHouse === 'Yes'
            ? inRate > 0
              ? inRate
              : netRate > 0
                ? netRate
                : originalMrp
            : originalMrp;

        const discount = parseFloat(product.discount) || 0;
        const qty = parseFloat(product.qty) || 0;
        const gst = parseFloat(product.gst) || 0;

        const rate = rateToUse - (rateToUse * discount) / 100;
        const amount = (rate * qty).toFixed(2);

        const gstAmount = (parseFloat(amount) * gst) / 100;
        const totalAmount =
          prev.inHouse === 'Yes'
            ? (parseFloat(amount) + gstAmount).toFixed(2)
            : (parseFloat(amount) - gstAmount).toFixed(2);

        return {
          ...product,
          mrp: originalMrp,
          rate: rate.toFixed(2),
          amount,
          totalAmount,
        };
      });

      return { ...prev, productList: updatedProductList };
    });
  }, [formData.inHouse]);

  const handleAddHsn = (values, { resetForm }) => {
    // Check if any product row has empty required fields
    const hasEmptyRows = formData.productList.some((product) => {
      return (
        !product.productId ||
        !product.productName ||
        !product.batchNo ||
        !product.qty ||
        !product.mrp ||
        !product.expDate
      );
    });

    if (hasEmptyRows) {
      toast.error('Please fill all required fields for products');
      return;
    }

    const payload = {
      ...formData,
      patientName: values.patientName,
      productList: formData.productList.map((product) => ({
        ...product,
        qty: parseFloat(product.qty),
        mrp: parseFloat(product.mrp),
        rate: parseFloat(product.rate),
        amount: parseFloat(product.amount),
        totalAmount: parseFloat(product.totalAmount),
        discount: parseFloat(product.discount || 0),
        gst: parseFloat(product.gst || 0),
      })),
    };

    dispatch(addSaleBill(payload, limits))
      .then((res) => {
        console.log('ressss', res);
        toggle();
        resetForm();
        setSelectedId(res?.data?.billId);
        // printToggle();
      })
      .catch((error) => {
        console.error('Error while adding sale bill:', error);
      });
  };

  const handleUpadteHsn = () => {
    const hasEmptyRows = formData.productList.some((product) => {
      return (
        !product.productId ||
        !product.productName ||
        !product.batchNo ||
        !product.qty ||
        !product.mrp ||
        !product.expDate
      );
    });

    if (hasEmptyRows) {
      toast.error('Please fill all required fields for products');
      return;
    }

    const payload = {
      ...formData,
      productList: formData.productList.map((product) => ({
        ...product,
        qty: parseFloat(product.qty),
        mrp: parseFloat(product.mrp),
        rate: parseFloat(product.rate),
        amount: parseFloat(product.amount),
        totalAmount: parseFloat(product.totalAmount),
        discount: parseFloat(product.discount || 0),
        gst: parseFloat(product.gst || 0),
      })),
    };

    dispatch(updateSaleBill(payload, limits, ids)).then(() => {
      setUpdateModal(false);
      setSelectedId(selectedId);
      // setShareWhasapp(true)
    });
  };

  const handleDeleteHsn = () => {
    dispatch(deleteSaleBill(ids, limits)).then(() => {
      deleteToggle();
      setMainPage(1);
    });
  };

  const handleSearch = (e) => {
    const newSearchQuery = e.target.value;
    setSearchQuery(newSearchQuery);
    const newSearchParams = {
      ...searchDefault,
      search: newSearchQuery || '',
      page: mainPage,
      limit: rowsPerPage,
    };
    setSearchDefault(newSearchParams);
    dispatch(getSaleBill(newSearchParams));
  };

  const ChangeMainPage = (selected) => {
    setMainPage(parseInt(selected.selected) + 1);
    const updatedSearchParams = {
      ...searchDefault,
      search: searchQuery,
      page: parseInt(selected.selected) + 1,
      limit: rowsPerPage,
    };
    setSearchDefault(updatedSearchParams);
    dispatch(getSaleBill(updatedSearchParams));
  };

  const handleRowsPerPageChange = (e) => {
    const newRowsPerPage = parseInt(e.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setMainPage(1);
  };

  const postPerPage = rowsPerPage;
  const PageCount = Math.ceil(
    bills?.getSaleBill?.data?.totalCount / postPerPage,
  );

  useEffect(() => {
    const updatedSearchParams = {
      ...searchDefault,
      search: searchQuery,
      page: mainPage,
      limit: rowsPerPage,
    };
    dispatch(getSaleBill(updatedSearchParams));
    dispatch(productDropdown());
    dispatch(patientDropdown());
  }, [mainPage, rowsPerPage]);

  const formatDateForInput = (date) => {
    if (!date) return '';
    const formattedDate = new Date(date).toISOString().split('T')[0];
    return formattedDate;
  };

  const handleSearchChange = (e) => {
    setSearchProduct(e.target.value.toLowerCase());
  };

  const filteredProducts =
    salesData?.productDropdown?.data?.productData?.filter((product) =>
      product.productName.toLowerCase().includes(searchProduct),
    );

  const handleDeleteRow = (index) => {
    setFormData((prevState) => {
      const updatedProductList = prevState.productList.filter(
        (_, i) => i !== index,
      );
      return {
        ...prevState,
        productList: updatedProductList,
      };
    });
  };

  const handleProductSelection = (e, res, index) => {
    handleData(e, res, index);

    const batchDropdown = batchRefs.current[index];
    if (batchDropdown) {
      batchDropdown.click();
    }
  };

  const handlePrint = () => {
    const salesIds = localStorage.getItem('salesId');
    setSelectedId(salesIds);
    viewToggle();

    const newWindow = window.open('', '_blank');

    if (newWindow) {
      newWindow.document.open();
      newWindow.document.write(`
                <html>
                    <head>
                        <title>Generate Bill</title>
                        <style>
                            @media print {
                                body {
                                    margin: 0;
                                    padding: 0;
                                    background-color: #fff;
                                    font-family: "Arial, sans-serif";
                                }
                                .content {
                                    width: 100%;
                                    max-width: 595pt;
                                    height: 100vh;
                                    margin: 0 auto;
                                    box-sizing: border-box;
                                    overflow: hidden;
                                }
                                .content table {
                                    width: 100%;
                                    border-collapse: collapse;
                                }
                                .content table, .content th, .content td {
                                    page-break-inside: avoid;
                                }
                                .content * {
                                    font-size: 14px;
                                }
                                .content div, .content p, .content span {
                                    page-break-inside: avoid;
                                }
                            }
                            .content {
                                height: 100vh;
                                transform: scale(0.95);
                                transform-origin: top left;
                            }
                        </style>
                    </head>
                    <body>
                        <div class="content">
                            ${billRef.current.innerHTML}
                        </div>
                    </body>
                </html>
            `);
      newWindow.document.close();

      newWindow.onload = () => {
        newWindow.print();
        newWindow.onafterprint = () => {
          newWindow.close();
        };
      };
    } else {
      console.error(
        'Unable to open the print window. Check pop-up blocker settings.',
      );
    }
  };

  return (
    <>
      <div className="mt-[100px] d-flex justify-content-end">
        <div className="d-flex items-center gap-3">
          <div className="bg-white shadow-shadows py-[8px] px-[20px] rounded-full flex items-center gap-2">
            <IoSearchOutline />
            <input
              type="text"
              name="search"
              value={searchQuery}
              onChange={handleSearch}
              className="w-full outline-none"
              placeholder="Search..."
            />
          </div>
          <Button
            onClick={toggle}
            className="!bg-theme-dark fw-bold d-flex align-item-center border-0"
          >
            <IoMdAdd className="mt-1 gap-1" />
            Add Invoice
          </Button>
        </div>
      </div>
      <div className="mt-[50px] mb-4">
        <div className="mb-3 flex items-center justify-between mt-5">
          <h3 className="fw-bold">Sales Invoice</h3>
          <div className="ms-auto border-r me-3 pe-3">
            Total Records:{' '}
            <span className="text-success underline underline-offset-2 ps-2">
              {bills?.getSaleBill?.data?.totalCount || 0}
            </span>
          </div>

          <div>
            Rows per page:
            <select
              value={rowsPerPage}
              onChange={handleRowsPerPageChange}
              className="ms-2 border rounded-md focus:outline-none"
            >
              <option value={10}>10</option>
              <option value={30}>30</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
              <option value={500}>500</option>
            </select>
          </div>
        </div>
        <TableContainer>
          <Table variant="striped" colorScheme="blackAlpha">
            <Thead>
              <Tr>
                <Th>Invoice Date</Th>
                <Th>Patient Name</Th>
                <Th>Phone Number</Th>
                <Th>Invoice No.</Th>
                <Th>City</Th>
                {role !== 'Admin' && <Th>Inhouse</Th>}
                <Th>Payment Type</Th>
                <Th>Gross Amount</Th>
                <Th>SGST</Th>
                <Th>CGST</Th>
                <Th>Discount Amount </Th>
                <Th>Discount (%)</Th>
                <Th>Charges</Th>
                <Th>Bill Amount</Th>
                <Th>User</Th>
                <Th>Remark</Th>
                <Th className="text-end sticky right-0 bg-white">Action</Th>
              </Tr>
            </Thead>
            <Tbody>
              {bills?.getSaleBill?.data?.data?.length > 0 ? (
                bills?.getSaleBill?.data?.data?.map((res, index) => {
                  return (
                    <Tr key={index}>
                      <Td className="min-w-[10px]">
                        {' '}
                        {new Date(res.invoiceDate).toLocaleDateString('en-GB', {
                          day: '2-digit',
                          month: '2-digit',
                          year: 'numeric',
                        })}
                      </Td>
                      <Td className="min-w-[10px] capitalize">
                        {res.patientName}
                      </Td>
                      <Td className="min-w-[10px]">{res.phoneNumber}</Td>
                      <Td className="min-w-[10px]">{res.invoiceNo}</Td>
                      <Td className="min-w-[10px] capitalize">{res.city}</Td>
                      {role !== 'Admin' && (
                        <Td className="min-w-[50px]">{res.inHouse}</Td>
                      )}
                      <Td className="min-w-[50px]">{res.paymentType}</Td>
                      <Td className="min-w-[50px]">{res.grossAmount}</Td>
                      <Td className="min-w-[50px]">{res.sgst}</Td>
                      <Td className="min-w-[50px]">{res.cgst}</Td>
                      <Td className="min-w-[50px]">
                        {res.discountAmount || '-'}
                      </Td>
                      <Td className="min-w-[50px]">{res.cDiscount || '-'}</Td>
                      <Td className="min-w-[50px]">{res.charges || '-'}</Td>
                      <Td className="min-w-[50px]">{res.billAmount}</Td>
                      <Td className="min-w-[50px]">{res?.billAddedBy}</Td>
                      <Td className="min-w-[50px] capitalize">{res.remark}</Td>
                      <Td
                        style={{
                          minWidth: '100px',
                          position: 'sticky',
                          right: '0',
                          backgroundColor: 'white',
                        }}
                      >
                        <div className="d-flex gap-3 justify-end">
                          <VscTarget
                            onClick={() => {
                              viewToggle();
                              handleView(res._id);
                            }}
                            className="cursor-pointer text-primary fs-5"
                          />
                          <FaEdit
                            onClick={() => {
                              updateToggle();
                              setIds(res._id);
                              setSelectedId(res._id);
                              setFormData(res);
                            }}
                            className="cursor-pointer border-green-color fs-5 text-success"
                            title="update"
                          />
                          <MdDelete
                            onClick={() => {
                              setIds(res._id);
                              deleteToggle();
                            }}
                            className="cursor-pointer border-green-color fs-5 text-danger"
                            title="delete"
                          />
                        </div>
                      </Td>
                    </Tr>
                  );
                })
              ) : (
                <Tr>
                  <Td colSpan={12}>No any data</Td>
                </Tr>
              )}
            </Tbody>
          </Table>
        </TableContainer>
      </div>

      <ReactPaginate
        breakLabel="..."
        nextLabel="next >"
        onPageChange={ChangeMainPage}
        pageRangeDisplayed={5}
        pageCount={PageCount}
        previousLabel="< previous"
        renderOnZeroPageCount={null}
        className="pagination"
      />

      {/* add Invoice */}

      <Modal show={show} onHide={toggle} className="purchase_bill">
        <Modal.Header closeButton>
          <Modal.Title>Add Invoice</Modal.Title>
        </Modal.Header>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleAddHsn}
        >
          {({ handleSubmit, setFieldValue, values }) => (
            <Form onSubmit={handleSubmit}>
              <Modal.Body>
                <div className="row">
                  <div className="col-2">
                    <Form.Group className="mb-3 relative">
                      <Form.Label>Patient Name</Form.Label>
                      <Form.Control
                        type="text"
                        value={searchTerm}
                        onChange={(e) => {
                          setSearchTerm(e.target.value);
                          setFieldValue('patientName', e.target.value);
                          setFormData((prev) => ({
                            ...prev,
                            patientName: e.target.value,
                          }));
                        }}
                        name="patientName"
                        autoComplete="off"
                        placeholder="Enter Patient Name"
                        className="shadow-none focus:!border-theme-dark"
                        onBlur={() =>
                          setTimeout(() => setDropdownVisible(false), 200)
                        }
                      />
                      {isDropdownVisible &&
                        dropdown?.patientDrodown?.data?.data?.filter((item) =>
                          item?.name
                            ?.toLowerCase()
                            .includes(searchTerm.toLowerCase()),
                        ).length > 0 && (
                          <div className="dropdown-menu h-[150px] overflow-y-auto show w-100">
                            {dropdown?.patientDrodown?.data?.data
                              ?.filter((item) =>
                                item?.name
                                  ?.toLowerCase()
                                  .includes(searchTerm.toLowerCase()),
                              )
                              .map((item) => (
                                <div
                                  key={item._id}
                                  className="dropdown-item"
                                  onClick={() => handleSelect(item)}
                                  style={{ cursor: 'pointer' }}
                                >
                                  {item.name} &nbsp; | &nbsp; {item.phoneNumber}
                                </div>
                              ))}
                          </div>
                        )}

                      {isDropdownVisible &&
                        dropdown?.patientDrodown?.data?.data?.filter((item) =>
                          item?.name
                            ?.toLowerCase()
                            .includes(searchTerm.toLowerCase()),
                        ).length === 0 && (
                          <div className="dropdown-menu show w-100">
                            <div className="dropdown-item">
                              No results found
                            </div>
                          </div>
                        )}
                      <ErrorMessage
                        name="patientName"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-2">
                    <Form.Group className="mb-3">
                      <Form.Label>Phone Number</Form.Label>
                      <Form.Control
                        type="text"
                        value={formData.phoneNumber}
                        onChange={handleData}
                        name="phoneNumber"
                        placeholder="Enter Phone Number"
                        className="shadow-none focus:!border-theme-dark"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-2">
                    <Form.Group className="mb-3">
                      <Form.Label>City</Form.Label>
                      <Form.Control
                        type="text"
                        name="city"
                        value={formData.city}
                        onChange={handleData}
                        placeholder="Enter City"
                        className="shadow-none focus:!border-theme-dark"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-2">
                    <Form.Group className="mb-3">
                      <Form.Label>Invoice Date</Form.Label>
                      <Form.Control
                        type="date"
                        name="invoiceDate"
                        value={formData.invoiceDate}
                        onChange={handleData}
                        placeholder="Enter Address"
                        className="shadow-none focus:!border-theme-dark"
                      />
                    </Form.Group>
                  </div>
                  {role !== 'Admin' && (
                    <div className="col-2">
                      <Form.Group className="mb-3">
                        <Form.Label>Inhouse</Form.Label>
                        <Dropdown>
                          <Dropdown.Toggle
                            className="w-full !text-gray-500 text-start shadow-none focus:!border-theme-dark !border-[#dee2e6] py-[6px] px-[12px] bg-transparent"
                            id="dropdown-basic"
                          >
                            {formData.inHouse || 'Select'}
                          </Dropdown.Toggle>

                          <Dropdown.Menu className="w-full">
                            {['Yes', 'No'].map((type) => (
                              <Dropdown.Item
                                key={type}
                                onClick={() =>
                                  handleData({
                                    target: { name: 'inHouse', value: type },
                                  })
                                }
                              >
                                {type}
                              </Dropdown.Item>
                            ))}
                          </Dropdown.Menu>
                        </Dropdown>
                      </Form.Group>
                    </div>
                  )}
                  <div className="col-2">
                    <Form.Group className="mb-3">
                      <Form.Label>Payment Type</Form.Label>
                      <Dropdown>
                        <Dropdown.Toggle
                          className="w-full !text-gray-500 text-start shadow-none focus:!border-theme-dark !border-[#dee2e6] py-[6px] px-[12px] bg-transparent"
                          id="dropdown-basic"
                        >
                          {dropdownValues.paymentType || 'Select'}
                        </Dropdown.Toggle>

                        <Dropdown.Menu className="w-full">
                          {[
                            'Cash',
                            'Online',
                            'Credit Card/Debit Card',
                            'Online (Gpay)',
                            'Net Banking',
                          ].map((type) => (
                            <Dropdown.Item
                              key={type}
                              onClick={() =>
                                handleData({
                                  target: { name: 'paymentType', value: type },
                                })
                              }
                            >
                              {type}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    </Form.Group>
                  </div>

                  <div className="col-12">
                    <div className="flex justify-end">
                      <div
                        className="text-2xl text-danger my-3"
                        onClick={handleAddRow}
                      >
                        <FiPlusCircle />
                      </div>
                    </div>
                    <table className="table table-bordered p-0 purchase_table">
                      <thead>
                        <tr className="text-center text-sm">
                          <th className="min-w-[200px]">Product Name</th>
                          <th className="!min-w-[100px]">HSN Code</th>
                          <th className="!min-w-[50px]">Pack</th>
                          <th className="!min-w-[50px]">MRP</th>
                          <th className="!min-w-[50px]">Batch</th>
                          <th className="!min-w-[50px]">Expire Date</th>
                          <th className="!min-w-[50px]">CD (%)</th>
                          <th className="!min-w-[50px]">Rate</th>
                          <th className="!min-w-[50px]">Qty</th>
                          <th className="!min-w-[30px]">Gross Amount</th>
                          <th className="!min-w-[30px]">GST (%)</th>
                          <th className="!min-w-[50px]">Amount</th>
                          <th className="!min-w-[30px]">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {formData.productList.map((product, index) => (
                          <tr className="text-sm align-middle" key={index}>
                            <td>
                              <Dropdown
                                ref={(el) => (productRefs.current[index] = el)}
                              >
                                <Dropdown.Toggle
                                  id="dropdown-basic"
                                  className="w-full uppercase !text-gray-500 text-start !text-sm shadow-none border-0 p-0 h-[20px] bg-transparent"
                                >
                                  {product.productName || ''}
                                </Dropdown.Toggle>

                                <Dropdown.Menu className="w-[250px] h-[200px] overflow-y-auto">
                                  <div className="text-sm pt-1 px-[16px]">
                                    <Form.Control
                                      type="text"
                                      as={Form.Control}
                                      value={searchProduct}
                                      onChange={handleSearchChange}
                                      placeholder="Search product"
                                      className="!shadow-none !text-sm focus:!border-theme-dark outline-none focus:!bg-transparent"
                                    />
                                  </div>
                                  {filteredProducts?.length > 0 ? (
                                    filteredProducts?.map((res) => {
                                      return (
                                        <Dropdown.Item
                                          className="text-sm uppercase"
                                          key={res._id}
                                          onClick={(e) =>
                                            handleProductSelection(
                                              e,
                                              res,
                                              index,
                                            )
                                          }
                                        >
                                          {res.productName}
                                        </Dropdown.Item>
                                      );
                                    })
                                  ) : (
                                    <Dropdown.Item>No any data</Dropdown.Item>
                                  )}
                                </Dropdown.Menu>
                              </Dropdown>
                            </td>
                            <td>
                              <Form.Control
                                type="text"
                                name="hsnCode"
                                readOnly
                                value={product.hsnCode || ''}
                                as={Form.Control}
                                className="border-0 p-0 shadow-none uppercase !text-sm outline-none"
                              />
                            </td>
                            <td>
                              <Form.Control
                                type="text"
                                readOnly
                                name="pack"
                                value={product?.pack || ''}
                                as={Form.Control}
                                className="border-0 p-0 shadow-none uppercase !text-sm outline-none"
                              />
                            </td>
                            <td>
                              <Form.Control
                                type="mrp"
                                readOnly
                                as={Form.Control}
                                value={product?.mrp || ''}
                                className="border-0 p-0 shadow-none !text-sm outline-none"
                              />
                            </td>
                            <td>
                              <Dropdown>
                                <Dropdown.Toggle
                                  ref={(el) => (batchRefs.current[index] = el)}
                                  id="dropdown-basic"
                                  className="w-full !text-gray-500 uppercase text-start !text-sm shadow-none border-0 p-0 h-[20px] bg-transparent"
                                >
                                  {product?.batchNo || ''}
                                </Dropdown.Toggle>

                                <Dropdown.Menu className="w-[350px] h-[200px] overflow-y-auto p-2">
                                  <div className="text-sm flex items-center justify-between border-b">
                                    <div className="col-3">Batch No</div>
                                    <div className="col-2">MRP</div>
                                    <div className="col-4">Expire Date</div>
                                    <div className="col-3">Qty</div>
                                  </div>
                                  {dropdown?.batchDropdown?.data?.data?.length >
                                  0 ? (
                                    dropdown?.batchDropdown?.data?.data?.map(
                                      (res) => {
                                        return (
                                          <div
                                            className="w-full !border-b"
                                            key={res._id}
                                            onClick={() =>
                                              handleBatchData(res, index)
                                            }
                                          >
                                            <Dropdown.Item className="w-full !flex px-0 items-center justify-between text-sm cursor-pointer">
                                              <div className="col-3 uppercase">
                                                {res.batchNumber}
                                              </div>
                                              <div className="col-2">
                                                {formData.inHouse === 'Yes'
                                                  ? parseFloat(
                                                      res.inRate ||
                                                        res.netRate ||
                                                        0,
                                                    ) > 0
                                                    ? res.inRate || res.netRate
                                                    : res.mrp
                                                  : res.mrp}
                                              </div>
                                              <div className="col-4">
                                                {res.expDate
                                                  ? new Date(
                                                      res.expDate,
                                                    ).toLocaleDateString(
                                                      'en-US',
                                                      {
                                                        year: 'numeric',
                                                        month: 'long',
                                                      },
                                                    )
                                                  : ''}
                                              </div>
                                              <div className="col-3">
                                                {res.qty}
                                              </div>
                                            </Dropdown.Item>
                                          </div>
                                        );
                                      },
                                    )
                                  ) : (
                                    <Dropdown.Item>No any data</Dropdown.Item>
                                  )}
                                </Dropdown.Menu>
                              </Dropdown>
                            </td>
                            <td>
                              <Form.Control
                                type="month"
                                readOnly
                                name="expDate"
                                value={
                                  product?.expDate
                                    ? product?.expDate.substring(0, 7)
                                    : ''
                                }
                                className="border-0 p-0 shadow-none !text-sm outline-none"
                              />
                            </td>
                            <td>
                              <Form.Control
                                type="text"
                                name="discount"
                                ref={(el) => (inputRefs.current.discount = el)}
                                onKeyDown={(e) => handleKeyDown('discount', e)}
                                value={product.discount || ''}
                                onChange={(e) => handleProductChange(e, index)}
                                className="border-0 p-0 shadow-none !text-sm outline-none"
                              />
                            </td>

                            <td>
                              <Form.Control
                                type="text"
                                name="rate"
                                value={product.rate || ''}
                                readOnly
                                className="border-0 p-0 shadow-none !text-sm outline-none"
                              />
                            </td>
                            <td>
                              <Form.Control
                                type="text"
                                name="qty"
                                ref={(el) => (inputRefs.current.qty = el)}
                                onKeyDown={(e) =>
                                  handleKeyDown('qty', e, index)
                                }
                                value={product.qty || ''}
                                onChange={(e) => handleProductChange(e, index)}
                                className="border-0 p-0 shadow-none !text-sm outline-none"
                              />
                            </td>
                            <td>
                              <Form.Control
                                type="text"
                                name="totalAmount"
                                readOnly
                                value={product.totalAmount || ''}
                                className="border-0 p-0 shadow-none !text-sm outline-none"
                              />
                            </td>
                            <td>
                              <Form.Control
                                type="text"
                                name="gst"
                                readOnly
                                value={`${product.gst || ''} (${product.gst ? ((Number(product.amount) * Number(product.gst)) / 100).toFixed(2) : '0.00'})`}
                                className="border-0 p-0 shadow-none !text-sm outline-none"
                              />
                            </td>
                            <td>
                              <Form.Control
                                type="text"
                                name="amount"
                                readOnly
                                value={product.amount || ''}
                                className="border-0 p-0 shadow-none !text-sm outline-none"
                              />
                            </td>
                            <td
                              className="min-w-[50px]"
                              align="center"
                              onClick={() => handleDeleteRow(index)}
                            >
                              <MdOutlineDeleteOutline className="text-danger text-xl cursor-pointer" />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  <div className="flex justify-between mt-4">
                    <div className="text-sm">
                      <div className="flex items-center gap-3 mb-2">
                        <div className="w-[100px]">Remark</div>
                        <div>
                          <Form.Control
                            type="text"
                            name="remark"
                            value={formData.remark}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                remark: e.target.value,
                              });
                            }}
                            className="!border-gray-300 p-1 shadow-none !text-sm outline-none"
                          />
                        </div>
                      </div>
                    </div>
                    <table className="text-sm">
                      <tr>
                        <td className="min-w-[200px]">Gross Amount</td>
                        <td>
                          <Form.Control
                            type="text"
                            value={formData.grossAmount || ''}
                            readOnly
                            className="!border-gray-300 p-1 shadow-none !text-sm outline-none"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="min-w-[200px]">SGST</td>
                        <td>
                          <Form.Control
                            type="text"
                            value={formData.sgst || ''}
                            readOnly
                            className="!border-gray-300 p-1 shadow-none !text-sm outline-none"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="min-w-[200px]">CGST</td>
                        <td>
                          <Form.Control
                            type="text"
                            value={formData.cgst || ''}
                            readOnly
                            className="!border-gray-300 p-1 shadow-none !text-sm outline-none"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>Discount Amount(rs)</td>
                        <td>
                          <Form.Control
                            type="text"
                            name="discountAmount"
                            onChange={handleInputChange}
                            className="!border-gray-300 p-1 shadow-none !text-sm outline-none"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>Discount (%)</td>
                        <td>
                          <Form.Control
                            type="text"
                            name="cDiscount"
                            onChange={handleInputChange}
                            className="!border-gray-300 p-1 shadow-none !text-sm outline-none"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>Charges</td>
                        <td>
                          <Form.Control
                            type="text"
                            value={formData.charges || ''}
                            onChange={(e) =>
                              setFormData((prev) => ({
                                ...prev,
                                charges: e.target.value,
                              }))
                            }
                            className="!border-gray-300 p-1 shadow-none !text-sm outline-none"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>Bill Amount</td>
                        <td>
                          <Form.Control
                            type="text"
                            value={formData.billAmount || ''}
                            className="!border-gray-300 p-1 shadow-none !text-sm outline-none"
                          />
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={toggle}
                  className="px-4 bg-transparent border-[1px] text-black border-green-color"
                >
                  Close
                </Button>
                <Button type="submit" className="!bg-theme-dark border-0 px-4">
                  Add
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>

      {/* update Invoice */}

      <Modal
        Modal
        show={updateModal}
        onHide={updateToggle}
        className="purchase_bill"
      >
        <Modal.Header closeButton>
          <Modal.Title>Update Invoice</Modal.Title>
        </Modal.Header>

        <Formik
          enableReinitialize={true}
          initialValues={formData}
          validationSchema={validationSchema}
          onSubmit={handleUpadteHsn}
        >
          {({ handleSubmit, setFieldValue, values }) => (
            <Form onSubmit={handleSubmit}>
              <Modal.Body>
                <div className="row">
                  <div className="col-2">
                    <Form.Group className="mb-3 relative">
                      <Form.Label>Patient Name</Form.Label>
                      <Form.Control
                        type="text"
                        value={formData.patientName}
                        onChange={(e) => {
                          setSearchTerm(e.target.value);
                          setFieldValue('patientName', e.target.value);
                          setFormData((prev) => ({
                            ...prev,
                            patientName: e.target.value,
                          }));
                        }}
                        name="patientName"
                        autoComplete="off"
                        placeholder="Enter Patient Name"
                        className="shadow-none focus:!border-theme-dark"
                        onBlur={() =>
                          setTimeout(() => setDropdownVisible(false), 200)
                        }
                      />
                      {isDropdownVisible &&
                        dropdown?.patientDrodown?.data?.data?.filter((item) =>
                          item?.name
                            ?.toLowerCase()
                            .includes(searchTerm.toLowerCase()),
                        ).length > 0 && (
                          <div className="dropdown-menu show w-100">
                            {dropdown?.patientDrodown?.data?.data
                              ?.filter((item) =>
                                item?.name
                                  ?.toLowerCase()
                                  .includes(searchTerm.toLowerCase()),
                              )
                              .map((item) => (
                                <div
                                  key={item._id}
                                  className="dropdown-item"
                                  onClick={() => handleSelect(item)}
                                  style={{ cursor: 'pointer' }}
                                >
                                  {item.name} &nbsp; | &nbsp; {item.phoneNumber}
                                </div>
                              ))}
                          </div>
                        )}

                      {isDropdownVisible &&
                        dropdown?.patientDrodown?.data?.data?.filter((item) =>
                          item?.name
                            ?.toLowerCase()
                            .includes(searchTerm.toLowerCase()),
                        ).length === 0 && (
                          <div className="dropdown-menu show w-100">
                            <div className="dropdown-item">
                              No results found
                            </div>
                          </div>
                        )}
                    </Form.Group>
                  </div>
                  <div className="col-2">
                    <Form.Group className="mb-3">
                      <Form.Label>Phone Number</Form.Label>
                      <Form.Control
                        type="text"
                        readOnly
                        value={formData.phoneNumber}
                        name="phoneNumber"
                        placeholder="Enter Phone Number"
                        className="shadow-none focus:!border-theme-dark"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-2">
                    <Form.Group className="mb-3">
                      <Form.Label>City</Form.Label>
                      <Form.Control
                        type="text"
                        name="city"
                        value={formData.city}
                        readOnly
                        placeholder="Enter City"
                        className="shadow-none focus:!border-theme-dark"
                      />
                    </Form.Group>
                  </div>
                  {role !== 'Admin' && (
                    <div className="col-2">
                      <Form.Group className="mb-3">
                        <Form.Label>Invoice Date</Form.Label>
                        <Form.Control
                          type="date"
                          name="invoiceDate"
                          value={formatDateForInput(formData.invoiceDate)}
                          onChange={handleData}
                          placeholder="Enter Address"
                          className="shadow-none focus:!border-theme-dark"
                        />
                      </Form.Group>
                    </div>
                  )}
                  {role !== 'Admin' && (
                    <div className="col-2">
                      <Form.Group className="mb-3">
                        <Form.Label>Inhouse</Form.Label>
                        <Dropdown>
                          <Dropdown.Toggle
                            className="w-full !text-gray-500 text-start shadow-none focus:!border-theme-dark !border-[#dee2e6] py-[6px] px-[12px] bg-transparent"
                            id="dropdown-basic"
                          >
                            {formData.inHouse || 'Select'}
                          </Dropdown.Toggle>

                          <Dropdown.Menu className="w-full">
                            {['Yes', 'No'].map((type) => (
                              <Dropdown.Item
                                key={type}
                                onClick={() =>
                                  handleData({
                                    target: { name: 'inHouse', value: type },
                                  })
                                }
                              >
                                {type}
                              </Dropdown.Item>
                            ))}
                          </Dropdown.Menu>
                        </Dropdown>
                      </Form.Group>
                    </div>
                  )}
                  <div className="col-2">
                    <Form.Group className="mb-3">
                      <Form.Label>Payment Type</Form.Label>
                      <Dropdown>
                        <Dropdown.Toggle
                          className="w-full !text-gray-500 text-start shadow-none focus:!border-theme-dark !border-[#dee2e6] py-[6px] px-[12px] bg-transparent"
                          id="dropdown-basic"
                        >
                          {formData.paymentType || 'Select'}
                        </Dropdown.Toggle>

                        <Dropdown.Menu className="w-full">
                          {[
                            'Cash',
                            'Online',
                            'Credit Card/Debit Card',
                            'Online (Gpay)',
                            'Net Banking',
                          ].map((type) => (
                            <Dropdown.Item
                              key={type}
                              onClick={() =>
                                handleData({
                                  target: { name: 'paymentType', value: type },
                                })
                              }
                            >
                              {type}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    </Form.Group>
                  </div>

                  <div className="col-12">
                    <div
                      className="flex justify-end text-2xl text-danger my-3"
                      onClick={handleAddRow}
                    >
                      <FiPlusCircle />
                    </div>
                    <table className="table table-bordered p-0 purchase_table">
                      <thead>
                        <tr className="text-center text-sm">
                          <th className="min-w-[200px]">Product Name</th>
                          <th className="!min-w-[100px]">HSN Code</th>
                          <th className="!min-w-[50px]">Pack</th>
                          <th className="!min-w-[50px]">MRP</th>
                          <th className="!min-w-[50px]">Batch</th>
                          <th className="!min-w-[50px]">Expire Date</th>
                          <th className="!min-w-[50px]">CD (%)</th>
                          <th className="!min-w-[50px]">Rate</th>
                          <th className="!min-w-[50px]">Qty</th>
                          <th className="!min-w-[30px]">Gross Amount</th>
                          <th className="!min-w-[30px]">GST (%)</th>
                          <th className="!min-w-[50px]">Amount</th>
                          <th className="!min-w-[30px]">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {formData.productList.map((product, index) => (
                          <tr className="text-sm align-middle" key={index}>
                            <td>
                              <Dropdown>
                                <Dropdown.Toggle
                                  className="w-full !text-gray-500 uppercase text-start !text-sm shadow-none border-0 p-0 h-[20px] bg-transparent"
                                  id="dropdown-basic"
                                >
                                  {product.productName || ''}
                                </Dropdown.Toggle>

                                <Dropdown.Menu className="w-[250px] h-[200px] overflow-y-auto p-2">
                                  <div className="text-sm pt-1">
                                    <Form.Control
                                      type="text"
                                      as={Form.Control}
                                      value={searchProduct}
                                      onChange={handleSearchChange}
                                      placeholder="Search product"
                                      className="!shadow-none !text-sm focus:!border-theme-dark outline-none focus:!bg-transparent"
                                    />
                                  </div>

                                  {filteredProducts?.length > 0 ? (
                                    filteredProducts?.map((res) => {
                                      return (
                                        <Dropdown.Item
                                          className="text-sm uppercase px-0"
                                          key={res._id}
                                          onClick={(e) =>
                                            handleProductSelection(
                                              e,
                                              res,
                                              index,
                                            )
                                          }
                                        >
                                          {res.productName}
                                        </Dropdown.Item>
                                      );
                                    })
                                  ) : (
                                    <Dropdown.Item>No any data</Dropdown.Item>
                                  )}
                                </Dropdown.Menu>
                              </Dropdown>
                            </td>
                            <td>
                              <Form.Control
                                type="text"
                                name="hsnCode"
                                readOnly
                                value={product.hsnCode || ''}
                                as={Form.Control}
                                className="border-0 p-0 shadow-none !text-sm outline-none"
                              />
                            </td>
                            <td>
                              <Form.Control
                                type="text"
                                readOnly
                                name="pack"
                                value={product?.pack || ''}
                                as={Form.Control}
                                className="border-0 p-0 shadow-none uppercase !text-sm outline-none"
                              />
                            </td>
                            <td>
                              <Form.Control
                                type="mrp"
                                readOnly
                                as={Form.Control}
                                value={product?.mrp || ''}
                                className="border-0 p-0 shadow-none !text-sm outline-none"
                              />
                            </td>
                            <td>
                              <Dropdown>
                                <Dropdown.Toggle
                                  ref={(el) => (batchRefs.current[index] = el)}
                                  className="w-full !text-gray-500 text-start !text-sm shadow-none border-0 p-0 h-[20px] bg-transparent"
                                  id="dropdown-basic"
                                >
                                  {product?.batchNo || ''}
                                </Dropdown.Toggle>

                                <Dropdown.Menu className="w-[350px] h-[200px] overflow-y-auto p-2">
                                  <div className="text-sm flex items-center justify-between border-b">
                                    <div className="col-3">Batch No</div>
                                    <div className="col-3">MRP</div>
                                    <div className="col-3">Expire Date</div>
                                    <div className="col-3 text-center">Qty</div>
                                  </div>
                                  {dropdown?.batchDropdown?.data?.data?.length >
                                  0 ? (
                                    dropdown?.batchDropdown?.data?.data?.map(
                                      (res) => {
                                        return (
                                          <div
                                            className="w-full !border-b"
                                            key={res._id}
                                            onClick={() =>
                                              handleBatchData(res, index)
                                            }
                                          >
                                            <Dropdown.Item className="w-full !flex px-0 items-center justify-between text-sm cursor-pointer">
                                              <div className="col-3">
                                                {res.batchNumber}
                                              </div>
                                              <div className="col-3">
                                                {formData.inHouse === 'Yes'
                                                  ? parseFloat(
                                                      res.inRate ||
                                                        res.netRate ||
                                                        0,
                                                    ) > 0
                                                    ? res.inRate || res.netRate
                                                    : res.mrp
                                                  : res.mrp}
                                              </div>
                                              <div className="col-3">
                                                {res.expDate
                                                  ? new Date(
                                                      res.expDate,
                                                    ).toLocaleDateString(
                                                      'en-US',
                                                      {
                                                        year: 'numeric',
                                                        month: 'long',
                                                      },
                                                    )
                                                  : ''}
                                              </div>
                                              <div className="col-3 text-center">
                                                {res.qty}
                                              </div>
                                            </Dropdown.Item>
                                          </div>
                                        );
                                      },
                                    )
                                  ) : (
                                    <Dropdown.Item>No any data</Dropdown.Item>
                                  )}
                                </Dropdown.Menu>
                              </Dropdown>
                            </td>
                            <td>
                              <Form.Control
                                type="month"
                                readOnly
                                name="expDate"
                                value={
                                  product?.expDate
                                    ? product?.expDate.substring(0, 7)
                                    : ''
                                }
                                className="border-0 p-0 shadow-none !text-sm outline-none"
                              />
                            </td>
                            <td>
                              <Form.Control
                                type="text"
                                name="discount"
                                value={product.discount || ''}
                                onChange={(e) => handleProductChange(e, index)}
                                className="border-0 p-0 shadow-none !text-sm outline-none"
                              />
                            </td>
                            <td>
                              <Form.Control
                                type="text"
                                name="rate"
                                value={product.rate || ''}
                                readOnly
                                className="border-0 p-0 shadow-none !text-sm outline-none"
                              />
                            </td>
                            <td>
                              <Form.Control
                                type="text"
                                name="qty"
                                value={product.qty || ''}
                                onChange={(e) => handleProductChange(e, index)}
                                className="border-0 p-0 shadow-none !text-sm outline-none"
                              />
                            </td>
                            <td>
                              <Form.Control
                                type="text"
                                name="totalAmount"
                                readOnly
                                value={product.totalAmount || ''}
                                className="border-0 p-0 shadow-none !text-sm outline-none"
                              />
                            </td>
                            <td>
                              <Form.Control
                                type="text"
                                name="gst"
                                readOnly
                                value={`${product.gst || ''} (${product.gst ? ((Number(product.amount) * Number(product.gst)) / 100).toFixed(2) : '0.00'})`}
                                className="border-0 p-0 shadow-none !text-sm outline-none"
                              />
                            </td>
                            <td>
                              <Form.Control
                                type="text"
                                name="amount"
                                readOnly
                                value={product.amount || ''}
                                className="border-0 p-0 shadow-none !text-sm outline-none"
                              />
                            </td>
                            <td
                              className="min-w-[50px]"
                              align="center"
                              onClick={() => handleDeleteRow(index)}
                            >
                              <MdOutlineDeleteOutline className="text-danger text-xl cursor-pointer" />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  <div className="flex justify-between mt-4">
                    <div className="text-sm">
                      <div className="flex items-center gap-3 mb-2">
                        <div className="w-[100px]">Remark</div>
                        <div>
                          <Form.Control
                            type="text"
                            name="remark"
                            value={formData.remark}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                remark: e.target.value,
                              });
                            }}
                            className="!border-gray-300 p-1 shadow-none !text-sm outline-none"
                          />
                        </div>
                      </div>
                    </div>
                    <table className="text-sm">
                      <tr>
                        <td className="min-w-[200px]">Gross Amount</td>
                        <td>
                          <Form.Control
                            type="text"
                            value={formData.grossAmount || ''}
                            readOnly
                            className="!border-gray-300 p-1 shadow-none !text-sm outline-none"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="min-w-[200px]">SGST</td>
                        <td>
                          <Form.Control
                            type="text"
                            value={formData.sgst || ''}
                            readOnly
                            className="!border-gray-300 p-1 shadow-none !text-sm outline-none"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="min-w-[200px]">CGST</td>
                        <td>
                          <Form.Control
                            type="text"
                            value={formData.cgst || ''}
                            readOnly
                            className="!border-gray-300 p-1 shadow-none !text-sm outline-none"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>Discount Amount(rs)</td>
                        <td>
                          <Form.Control
                            type="text"
                            name="discountAmount"
                            value={formData.discountAmount}
                            onChange={handleInputChange}
                            className="!border-gray-300 p-1 shadow-none !text-sm outline-none"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>Discount (%)</td>
                        <td>
                          <Form.Control
                            type="text"
                            name="cDiscount"
                            value={formData.cDiscount}
                            onChange={handleInputChange}
                            className="!border-gray-300 p-1 shadow-none !text-sm outline-none"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>Charges</td>
                        <td>
                          <Form.Control
                            type="text"
                            value={formData.charges || ''}
                            onChange={(e) =>
                              setFormData((prev) => ({
                                ...prev,
                                charges: e.target.value,
                              }))
                            }
                            className="!border-gray-300 p-1 shadow-none !text-sm outline-none"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>Bill Amount</td>
                        <td>
                          <Form.Control
                            type="text"
                            value={formData.billAmount || ''}
                            className="!border-gray-300 p-1 shadow-none !text-sm outline-none"
                          />
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={updateToggle}
                  className="px-4 bg-transparent border-[1px] text-black border-green-color"
                >
                  Close
                </Button>
                <Button type="submit" className="!bg-theme-dark border-0 px-4">
                  Update
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>

      {/* delete Invoice */}

      <Modal Modal show={deleteModal} onHide={deleteToggle}>
        <Modal.Body className="p-5">
          <div>
            <PiWarningCircleBold className="text-7xl w-100 text-danger" />
          </div>
          <div className="text-center mt-4">
            <h3>Are You Sure ?</h3>
            <p className="text-md">
              Do you really want to delete these records?
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={deleteToggle}
            className="px-4 bg-transparent border-[1px] text-black border-green-color"
          >
            No
          </Button>
          <Button
            type="submit"
            className="bg-danger border-0 px-4"
            onClick={handleDeleteHsn}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>

      {/* View modal */}
      <Modal show={viewModal} onHide={viewToggle} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>Product List</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-5">
          <div className="table-responsive">
            <table className="table table-bordered p-0">
              <thead>
                <tr className="text-center text-sm">
                  <th className="min-w-[300px]">Product Name</th>
                  <th className="!min-w-[100px]">HSN Code</th>
                  <th className="!min-w-[100px]">Pack</th>
                  <th className="!min-w-[100px]">MRP</th>
                  <th className="!min-w-[100px]">Batch</th>
                  <th className="!min-w-[100px]">Expire Date</th>
                  <th className="!min-w-[100px]">CD (%)</th>
                  <th className="!min-w-[100px]">Rate</th>
                  <th className="!min-w-[100px]">Qty</th>
                  <th className="!min-w-[100px]">Amount</th>
                  <th className="!min-w-[100px]">GST (%)</th>
                  <th className="!min-w-[100px]">Total Amount</th>
                </tr>
              </thead>
              <tbody>
                {bills?.viewSaleBill?.data?.data?.productList?.length > 0 ? (
                  bills?.viewSaleBill?.data?.data?.productList?.map((res) => {
                    return (
                      <tr>
                        <td className="uppercase">{res.productName}</td>
                        <td className="uppercase">{res.hsnCode}</td>
                        <td className="uppercase">{res.pack}</td>
                        <td>{res.mrp}</td>
                        <td className="uppercase">{res.batchNo}</td>
                        <td>
                          {new Date(res.expDate).toLocaleDateString('en-GB', {
                            month: '2-digit',
                            year: 'numeric',
                          })}
                        </td>
                        <td>{res.discount}</td>
                        <td>{res.rate}</td>
                        <td>{res.qty}</td>
                        <td>{res.amount}</td>
                        <td>{res.gst}</td>
                        <td>{res.totalAmount}</td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={14}>No any data</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div className="text-end mt-4">
            <Button
              type="submit"
              className="!bg-theme-dark border-0 px-4"
              onClick={handlePrint}
            >
              Print
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      {/* print modal */}

      <Modal Modal show={printModal} onHide={printToggle}>
        <Modal.Body className="p-5">
          <div>
            <RiDownloadCloudLine className="text-7xl w-100 text-danger" />
          </div>
          <div className="text-center mt-4">
            <h3>Do you want to print ?</h3>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={printToggle}
            className="px-4 bg-transparent border-[1px] text-black border-green-color"
          >
            No
          </Button>
          <Button
            type="submit"
            className="bg-danger border-0 px-4"
            onClick={handlePrint}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal Modal show={shareWhasapp} onHide={shareWhasappToggle}>
        <Modal.Body className="p-5">
          <div>
            <RiDownloadCloudLine className="text-7xl w-100 text-danger" />
          </div>
          <div className="text-center mt-4">
            <h3>Do you want to share invoice in whasapp?</h3>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={shareWhasappToggle}
            className="px-4 bg-transparent border-[1px] text-black border-green-color"
          >
            No
          </Button>
          <Button
            type="submit"
            className="bg-danger border-0 px-4"
            onClick={DownloadPdf}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>

      <div
        ref={billRef}
        id="invoice"
        className="d-none"
        style={{ fontSize: '10px' }}
      >
        <div
          style={{
            fontFamily: 'Arial, sans-serif',
            backgroundColor: '#fff',
            width: '100%',
            maxWidth: '595pt',
            minHeight: '842pt',
            overflow: 'hidden',
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            margin: 'auto',
          }}
        >
          <div
            style={{
              width: '100%',
              borderBottom: '1px solid #A0AEC0',
              paddingBottom: '5px',
              padding: '10mm',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <div style={{ marginBottom: '10px' }}>
              <img
                src={aboutInfo?.[0]?.logo}
                crossOrigin="anonymous"
                alt="Sculpt logo"
                style={{ height: '70px' }}
              />
            </div>
            <div style={{ fontSize: '14px', color: 'black', width: '300px' }}>
              {aboutInfo?.[0]?.address}{' '}
              <div style={{ marginTop: '5px' }}>
                <span style={{ fontWeight: 'bold' }}>Phone No:</span>{' '}
                {aboutInfo?.[0]?.mobileNumber}
              </div>
            </div>
          </div>

          <div
            style={{
              flex: '1',
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <div
              style={{
                width: '100%',
                paddingLeft: '10px',
                fontSize: '12px',
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div>
                  <p>
                    <strong>Patient Name : </strong> {userData?.patientName}
                  </p>
                  <p>
                    <strong>Invoice Number : </strong> {userData?.invoiceNo}
                  </p>
                </div>
                <div>
                  <p>
                    <strong>Dr. Name : </strong> DR. Kinjal Pathak
                  </p>
                  <p>
                    <strong>Bill Date : </strong>
                    {new Date(userData?.invoiceDate).toLocaleDateString(
                      'en-GB',
                      { day: '2-digit', month: '2-digit', year: 'numeric' },
                    )}
                  </p>
                </div>
                <div>
                  <p>
                    <strong>City : </strong> {userData?.city}
                  </p>
                </div>
              </div>
              <hr style={{ color: '#d68000', fontWeight: 'bold' }} />
              <div
                style={{
                  flex: '1',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <table
                  style={{
                    width: '100%',
                    borderCollapse: 'collapse',
                    marginTop: '10px',
                    textAlign: 'center',
                    flex: '1',
                    overflow: 'auto',
                  }}
                >
                  <thead>
                    <tr>
                      <th style={{ border: '1px solid gray', padding: '8px' }}>
                        SR.
                      </th>
                      <th style={{ border: '1px solid gray', padding: '8px' }}>
                        Company
                      </th>
                      <th style={{ border: '1px solid gray', padding: '8px' }}>
                        Description
                      </th>
                      <th style={{ border: '1px solid gray', padding: '8px' }}>
                        Pack
                      </th>
                      <th style={{ border: '1px solid gray', padding: '8px' }}>
                        HSN
                      </th>
                      <th style={{ border: '1px solid gray', padding: '8px' }}>
                        Exp. Date
                      </th>
                      <th style={{ border: '1px solid gray', padding: '8px' }}>
                        Batch No.
                      </th>
                      <th style={{ border: '1px solid gray', padding: '8px' }}>
                        Qty
                      </th>
                      <th style={{ border: '1px solid gray', padding: '8px' }}>
                        MRP
                      </th>
                      {/* <th style={{ border: '1px solid gray', padding: '8px' }}>Rate</th> */}
                      <th style={{ border: '1px solid gray', padding: '8px' }}>
                        Amount
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {userData?.productList?.length > 0 ? (
                      userData?.productList?.map((res, index) => {
                        return (
                          <tr valign="top" key={index}>
                            <td
                              style={{
                                border: '1px solid gray',
                                padding: '8px',
                              }}
                            >
                              {index + 1}
                            </td>
                            <td
                              style={{
                                border: '1px solid gray',
                                padding: '8px',
                                textTransform: 'uppercase',
                              }}
                            >
                              etdicare
                            </td>
                            <td
                              style={{
                                border: '1px solid gray',
                                padding: '8px',
                                textTransform: 'uppercase',
                              }}
                            >
                              {res.productName}
                            </td>
                            <td
                              style={{
                                border: '1px solid gray',
                                padding: '8px',
                                textTransform: 'uppercase',
                              }}
                            >
                              {res.pack}
                            </td>
                            <td
                              style={{
                                border: '1px solid gray',
                                padding: '8px',
                              }}
                            >
                              {res.hsnCode}
                            </td>
                            <td
                              style={{
                                border: '1px solid gray',
                                padding: '8px',
                              }}
                            >
                              {new Date(res?.expDate).toLocaleDateString(
                                'en-GB',
                                { month: '2-digit', year: 'numeric' },
                              )}
                            </td>
                            <td
                              style={{
                                border: '1px solid gray',
                                padding: '8px',
                                textTransform: 'uppercase',
                              }}
                            >
                              {res.batchNo}
                            </td>
                            <td
                              style={{
                                border: '1px solid gray',
                                padding: '8px',
                              }}
                            >
                              {res.qty}
                            </td>
                            <td
                              style={{
                                border: '1px solid gray',
                                padding: '8px',
                              }}
                            >
                              {res.mrp}
                            </td>
                            {/* <td style={{ border: '1px solid gray', padding: '8px' }}>{res.rate}</td> */}
                            <td
                              style={{
                                border: '1px solid gray',
                                padding: '8px',
                              }}
                            >
                              {res.amount}
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan={11} align="center">
                          No any data
                        </td>
                      </tr>
                    )}

                    <tr>
                      <td
                        colSpan={7}
                        style={{
                          border: '1px solid gray',
                          padding: '8px',
                          textAlign: 'left',
                          textTransform: 'capitalize',
                        }}
                      >
                        Rs: {totalAmountInWords}
                      </td>
                      <td style={{ border: '1px solid gray', padding: '8px' }}>
                        {totalQty}
                      </td>
                      <td
                        style={{ border: '1px solid gray', padding: '8px' }}
                      ></td>
                      <td style={{ border: '1px solid gray', padding: '8px' }}>
                        {userData?.grossAmount}
                      </td>
                    </tr>
                    <tr>
                      <td
                        colSpan={5}
                        style={{
                          border: '1px solid gray',
                          padding: '8px',
                          textAlign: 'left',
                        }}
                      >
                        <p>
                          <strong>D.L. No. : </strong> GJ-SUR-2
                        </p>
                        <p>
                          <strong>GSTN : </strong> {aboutInfo?.[0]?.gstIn},
                          Registered
                        </p>
                        <p>
                          <strong>PAN : </strong> {aboutInfo?.[0]?.panNo}
                        </p>
                        <p></p>
                      </td>
                      <td
                        valign="top"
                        colSpan={3}
                        style={{
                          border: '1px solid gray',
                          padding: '8px',
                          textAlign: 'right',
                        }}
                      >
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                            height: '100px',
                          }}
                        >
                          <p style={{ margin: '0px' }}>
                            <strong>For, ARK CHEMIST</strong>
                          </p>
                          <p style={{ margin: '0px', marginTop: 'auto' }}>
                            <img
                              src={aboutInfo?.[0]?.signature}
                              crossOrigin="anonymous"
                              alt="Sculpt signature"
                              style={{ height: '70px' }}
                            ></img>
                            <strong style={{ display: 'block' }}>
                              Authorised Signatory
                            </strong>
                          </p>
                        </div>
                      </td>
                      <td
                        valign="top"
                        style={{ border: '1px solid gray', padding: '8px' }}
                      >
                        <p>
                          <strong>Gross</strong>
                        </p>
                        {totalDis > 0 && (
                          <p>
                            <strong>Discount</strong>
                          </p>
                        )}
                      </td>
                      <td
                        valign="top"
                        style={{ border: '1px solid gray', padding: '8px' }}
                      >
                        <p>
                          <strong>{userData?.grossAmount}</strong>
                        </p>
                        {totalDis > 0 && (
                          <p>
                            <strong>{totalDis} %</strong>
                          </p>
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td
                        colSpan={5}
                        style={{
                          border: '1px solid gray',
                          padding: '8px',
                          textAlign: 'left',
                        }}
                      >
                        {/* <p style={{ margin: '0px' }}>Consult Doctor Before Use of Medicine</p>
                                            <p style={{ margin: '0px' }}>Subject to PALANPUR Jurisdiction only.</p> */}
                        <b>Payment Type:</b> {userData?.paymentType}
                      </td>
                      <td
                        valign="top"
                        colSpan={3}
                        style={{
                          border: '1px solid gray',
                          padding: '8px',
                          textAlign: 'left',
                        }}
                      >
                        <p>
                          <strong>Message: </strong>
                        </p>
                      </td>
                      <td
                        valign="top"
                        style={{ border: '1px solid gray', padding: '8px' }}
                      >
                        <p>
                          <strong>Grand Total</strong>
                        </p>
                      </td>
                      <td
                        valign="top"
                        style={{ border: '1px solid gray', padding: '8px' }}
                      >
                        <p>
                          <strong>{userData?.billAmount}</strong>
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {/* <div
                    style={{
                        position: 'fixed',
                        bottom: '0',
                        width: "100%",
                        borderTop: "5px solid #f2c07b",
                        paddingLeft: "15px",
                        paddingRight: '15px',
                        display: 'flex',
                        justifyContent: 'space-between',
                        paddingBottom: "10px",
                        boxSizing: 'border-box',
                    }}
                >
                    <div style={{ marginTop: '10px' }}>
                        <span style={{ fontSize: '16px', fontWeight: 'bold', color: '#f0cf9b' }}>Sculpt Skin Care</span>
                        <p style={{ fontSize: '16px', color: 'black', width: "300px" }}>
                            503, Swastik House, Kargil Chowk, Nr. Shardayatan School, Piplod, Surat, Gujarat 395007
                        </p>
                    </div>
                    <div style={{ marginTop: '15px', display: "grid" }}>
                        <p style={{ fontSize: "16px", color: "black", display: "flex", gap: '5px', marginBottom: "0px" }}>
                            <span style={{ fontSize: '16px', fontWeight: 'bold', color: '#f0cf9b' }}>CALL: </span> +91 75750 96668
                        </p>
                        <p style={{ fontSize: "16px", color: "black", display: "flex", gap: '5px', marginBottom: "20px" }}>
                            <span style={{ fontSize: '16px', fontWeight: 'bold', color: '#f0cf9b' }}>WEBSITE: </span> sculptskincare.in
                        </p>
                    </div>
                </div> */}
        </div>
      </div>

      <SalesPrint billRef={billRef} selectedId={selectedId} />
    </>
  );
}
